const config = {
  baseUrl: 'https://beta-th-api.dimorder.com',
};

export default config;
